/**
 * Created by danielr on 6/16/15.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var AppKeyModel = require("manager-models/data-sources/integrations/app-keys/AppKeyModel");
    var BaseCollection = require("collections/BaseCollection");
    var ApiResources = require("assets/data/apiResources.json");

    var NAME = "AppKeysCollection";

    var AppKeysCollection = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        AppKeysCollection = BaseCollection.extend({
            name: NAME,
            model: AppKeyModel,
            resource: ApiResources.Applications.AppKey
        });
    }

    LE.module("LEManager", moduleDefinition);

    AppKeysCollection.NAME = NAME;

    return AppKeysCollection;
});
